module.exports = __webpack_public_path__ + "static/media/01C.6b77a2fa.png";